import React, { useEffect, useMemo, useState } from "react";
import * as S from "./ListStages.style";
import * as P from "../../../../../../../utils/pipes";
import { useTranslation } from "react-i18next";
import ZaiaReaction from "../../../../../../zaiaComponents/zaiaReaction/ZaiaReaction";

const logoZaiaEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-no-data-loaded.svg`;

function ListStages({
  patient,
  processSelected,
  frequency,
  newCurrenStatusData,
  processStagesData,
  statusSelectionView,
  currentStatus,
  newCurrentStatus,
  setNewCurrentStatus,
  groupStageId,
  counterStage,
  setCounterStage,
  newCounterStage,
  setNewCounterStage
}) {

  const {t, i18n: { language }} = useTranslation("global");

  const filterStages = (stage) => {       
    if(groupStageId || groupStageId === 0) {
      return groupStageId === 0
        ? stage.groupStageValue === null
        : stage.groupStageValue === groupStageId
    } else {
      return true
    }
  }


  // order by P.dataTranslation(b.stageName, language))
  const processStagesOrdered = useMemo(() => {
    if (!processStagesData?.process[0]?.processStages) return [];

    return [...processStagesData?.process[0]?.processStages].sort((a, b) =>
      (P.dataTranslation(a.stageName, language) ?? "").localeCompare(P.dataTranslation(b.stageName, language) ?? "", "en", {
        sensitivity: "base"
      })
    );
  }, [processStagesData]);


  const sortedStages = useMemo(() => {
    return processStagesOrdered
      ?.slice()
      .sort((a, b) =>
        P.dataTranslation(a.stageName, language).localeCompare(
          P.dataTranslation(b.stageName, language),
          language,
          { numeric: true, sensitivity: "base" }
        )
      );
  }, [processStagesOrdered, language]);

  return (
    <S.ListStages>
      <div className="status-list">
        {
          processStagesData?.process[0]?.processStages?.filter((stage) => filterStages(stage)).length === 0 &&
          <div className="status-empty">
            <ZaiaReaction
              zaiaImg={logoZaiaEmpty}
              text={t("changeOfStatus.noStatesAvailable")} 
            />
          </div>
        }
        { 
          sortedStages?.map(
            (stage) => {
              if(filterStages(stage)) return (
                <div className="status-item">
                  <button className={
                      `status-item__button 
                      ${
                        stage.id === newCurrentStatus
                          ? "status-item__button--selected"
                          : ""
                      }`
                    }
                    onClick={() => {
                      setNewCurrentStatus(stage.id);
                    }}
                  >
                    <div className="status-item__left">
                      <div className="status-item__radio-button">
                        {
                          ((stage.id === currentStatus && newCurrentStatus === currentStatus) || stage.id === newCurrentStatus) &&
                          <div className="status-item__radio-button-content"></div>
                        }
                      </div>
                      <div className="status-item__text">
                        {P.dataTranslation(stage.stageName, language)}
                      </div>
                      {
                        stage?.incremental && stage.id === newCurrentStatus &&
                        <div className="status-item__counter">
                          <div className="counter__button"
                            onClick={() => newCounterStage > 1 && setNewCounterStage(newCounterStage-1)}
                          >
                            <i className="zaia-icono-atras"></i>
                          </div>
                          <div className="counter__number">
                            {
                              newCounterStage
                            }
                          </div>
                          <div className="counter__button"
                            onClick={() => setNewCounterStage(newCounterStage+1)}
                          >
                            <i className="zaia-i-next"></i>
                          </div>
                        </div>
                      }
                    </div>
                    <div className={
                      `status-item__caption
                      ${
                        stage.id === newCurrentStatus
                          ? "status-item__caption--selected"
                          : ""
                      }`
                    }>
                      {
                        stage.id === currentStatus &&
                        t("changeOfStatus.currentStatus")
                      }
                      {
                        stage.id === newCurrentStatus && newCurrentStatus !== currentStatus &&
                        t("changeOfStatus.newStatus")
                      }
                    </div>
                  </button>
                  <div 
                    
                  >
                  </div>
                </div>
              )
            }
          )
        }
      </div>
    </S.ListStages>
  );
}

export default ListStages;
